/**
 * A manufactured component / part that can be analysed for cleanliness.
 *
 * The domain interface uses camelCase properties.
 * The TypeORM EntitySchema maps each property to its snake_case column.
 *
 * Scoped to a site (identity_sites UUID, D6) and has a part number (UUID).
 */
export interface Part {
	id: string;
	partNumber: string;
	partName: string;
	siteId: string | null;
	imageBlobPath: string | null;
	active: boolean;
	createdAt: Date;
	updatedAt: Date;
}

/** Input for creating a new part */
export interface CreatePartInput {
	partNumber: string;
	partName: string;
	siteId?: string | null;
	imageBlobPath?: string | null;
	active?: boolean;
}

/** Builds the full blob-storage path for a part image blob. */
export function partImageBlobPath(uuid: string): string {
	return `part/${uuid}`;
}
